import clsx from "clsx";
import { FormFieldComponentProps } from "./types";

export const MULTILINE_MAX_LENGTH = 1600;
export default function MultiLineTextField({
  id,
  label,
  required,
  value,
  error,
  onChange,
}: FormFieldComponentProps) {
  const overLimit = value.length > MULTILINE_MAX_LENGTH;
  return (
    <div className={clsx("field", (error || overLimit) && "invalid")}>
      <label htmlFor={id} className="label">
        {label}
        {required && " *"}
      </label>
      <textarea
        id={id}
        name={id}
        rows={4}
        required={required}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={!!error || overLimit}
        aria-describedby={`${id}-count${error ? ` ${id}-error` : ""}`}
        className="value"
      />
      {error && (
        <p id={`${id}-error`} role="alert" className="error">
          • {error}
        </p>
      )}
      <span id={`${id}-count`} aria-live="polite" className="counter">
        {value.length}/{MULTILINE_MAX_LENGTH}
      </span>
    </div>
  );
}
